import { useGetCompanyQuery } from "../../../../store/Company/companyApiSlice";
import { useGetCompanyNewQuery } from "../../../../store/search/searchApiSlice";
import { resolveStatus } from "../../../common/u1/StatusBadge";

/* Resolving one purchase to a company. */
export const purchaseKey = (row, index = 0) =>
  row?.purchaseID || row?.id || `purchase-${index}`;

export const usePurchasedCompany = (row, token) => {
  const companyID = row?.companyID;
  const isTrevex = String(companyID || "").startsWith("TRX");

  const { data: trevexCompany } = useGetCompanyQuery(
    { token, companyId: isTrevex ? companyID : "" },
    { skip: !isTrevex }
  );
  const { data: worldBox } = useGetCompanyNewQuery(
    { id: isTrevex ? "" : companyID },
    { skip: isTrevex }
  );

  const wbCompany = worldBox?.company;

  /* Transcribed fallback chain, order included. */
  const company = isTrevex
    ? trevexCompany
    : {
        ...wbCompany,
        name: wbCompany?.name || row?.company_name,
        state: wbCompany?.city || row?.city,
        country_code: wbCompany?.countrycode || row?.country_code,
        /* The live card links a WorldBox record by its `win`. */
        wb_win: wbCompany?.win,
      };

  /* Only a TREVEX record has a profile status worth naming; a WorldBox record
     is not on TREVEX at all, so its report is analyst-built. */
  const statusLabel =
    isTrevex && trevexCompany
      ? { verified: "Verified", claimed: "Claimed", listed: null }[
          resolveStatus(trevexCompany).status
        ]
      : null;

  return {
    company,
    isTrevex,
    displayName: company?.name || company?.registered_company_name || "",
    statusLabel,
    /* What the public-profile link is keyed by. */
    profileKey: isTrevex ? trevexCompany?.companyID || companyID : wbCompany?.win,
  };
};

export default usePurchasedCompany;
